import { Component, OnInit } from '@angular/core';
import { EcapTranslateService } from '@ecap3/core';

@Component({
    selector: 'app-not-found-site-domain',
    templateUrl: './site-domain.component.html',
    styleUrls: ['./site-domain.component.scss']
})
export class NotFoundSiteDomainComponent {
    constructor(private translateService: EcapTranslateService) {}
}
